import { AddressFormatter } from "@shared/utils/address-formatter";
import { SmartAddress } from "@uxf/smart-address/v1";

export const smartAddressLoadOptions = SmartAddress.createAddressLoader({
    level: 1,
    getLabel: (address) => AddressFormatter.formatAddress(address),
});
